/* ==== ATS PDP — externalized JS (UPDATED: Splide-safe media filtering) ==== */
(function () {
  'use strict';

  const SECTION_SELECTOR = '[data-section-type="ats-pdp"]';
  const CLICK_SELECTOR = '.ATS-pill, .ATS-color-swatch, .ATS-pill-below, .ATS-variantCard';

  function initSection(root) {
    if (!root || root.dataset.init === '1') return;
    root.dataset.init = '1';

    const productScript = root.querySelector('script[data-product-json]');
    let productData = null;
    // Maps media-id to slide index for each splide
const mediaIndexMap = new WeakMap();

    try {
      productData = JSON.parse(productScript?.textContent || '{}');
    } catch (e) {}

    const linkMediaEnabled =
      String(root.getAttribute('data-link-media') || root.dataset.linkMedia || '').toLowerCase() === 'true';

    /* =========================================================
       ✅ GALLERY FILTERING (Splide-safe)
       - NEVER display:none Splide slides
       - Rebuild slide list + destroy/remount Splide
    ========================================================= */
    if (linkMediaEnabled) {
      const allMediaNodes = Array.from(root.querySelectorAll('[data-media-id]'));

      // Non-splide media nodes can safely be display:none (thumbs, grid buttons, feature thumbs)
      const nonSplideNodes = allMediaNodes.filter((el) => !el.closest('.splide'));

      // ---- helpers ----
      const normLower = (s) =>
        String(s || '')
          .trim()
          .toLowerCase();

      function getVariantTagFromAlt(altText) {
        const alt = String(altText || '').trim();
        // ALT must start: |#v:1P (spaces allowed)
        const m = alt.match(/^\s*\|\s*#v:\s*([^|]+)\s*/i);
        if (!m) return null;
        return normLower(m[1]); // "1p"
      }

      // mediaId -> tag ("1p", "2p"...)
      const mediaTagById = new Map();

      // Read tag from ANY node that has an <img alt="">
      allMediaNodes.forEach((el) => {
        const mediaId = String(el.dataset.mediaId || '');
        if (!mediaId || mediaTagById.has(mediaId)) return;

        const img = el.querySelector('img[alt]');
        const alt = img ? img.getAttribute('alt') : '';
        const tag = getVariantTagFromAlt(alt);
        if (tag) mediaTagById.set(mediaId, tag);
      });

      // ---- Splide cache/store ----
      const splideEls = Array.from(root.querySelectorAll('.splide[data-ats-splide]'));
      const splideStore = new WeakMap();

      function parseJSONAttr(el, attr) {
        const raw = el.getAttribute(attr);
        if (!raw) return {};
        try {
          return JSON.parse(raw);
        } catch (e) {
          return {};
        }
      }

      function getSplideInstance(el) {
        return el.__splide || el.splide || null;
      }

      function cacheSplide(el) {
        if (splideStore.has(el)) return;
        const list = el.querySelector('.splide__list');
        if (!list) return;

        splideStore.set(el, {
          opts: parseJSONAttr(el, 'data-ats-splide'),
          slides: Array.from(list.children).map((li) => li.cloneNode(true)), // clone original
        });
      }

      splideEls.forEach(cacheSplide);

      function destroySplide(el) {
        const inst = getSplideInstance(el);
        if (inst && inst.destroy) inst.destroy(true);
      }

      function mountSplide(el) {
        const state = splideStore.get(el);
        if (!state) return;

        const oldInst = getSplideInstance(el);
        const Ctor = (oldInst && oldInst.constructor) || window.Splide;
        if (!Ctor) return;

        const opts = Object.assign({}, state.opts, { start: 0 });
        const s = new Ctor(el, opts);
        if (s.mount) s.mount();

        // keep compatibility with your other scripts
        el.__splide = s;
        el.splide = s;
      }

      function rebuildSplide(el, allowedIds) {
        const state = splideStore.get(el);
        const list = el.querySelector('.splide__list');
        if (!state || !list) return;

        // 1) destroy existing instance first
        destroySplide(el);

        // 2) rebuild list
        const hasFilter = allowedIds && allowedIds.size > 0;

        const nextSlides = hasFilter
          ? state.slides.filter((li) => {
              const id = String(li.dataset.mediaId || li.getAttribute('data-media-id') || '');
              return allowedIds.has(id);
            })
          : state.slides;

        // if filter matches nothing -> fallback restore all
        const finalSlides = nextSlides.length ? nextSlides : state.slides;

        list.innerHTML = '';
        finalSlides.forEach((li) => list.appendChild(li.cloneNode(true)));
// ---- Build mediaId -> slide index map ----
const map = {};
Array.from(list.children).forEach((li, i) => {
  const id = String(li.dataset.mediaId || li.getAttribute('data-media-id') || '');
  if (id) map[id] = i;
});
mediaIndexMap.set(el, map);

        // 3) remount Splide so it recalculates correctly
        mountSplide(el);

        // let other scripts (progress bar etc.) know
        document.dispatchEvent(new CustomEvent('ats:splide:remounted', { detail: { el, root } }));
      }

      function setVisibilityNonSplide(el, show) {
        el.style.display = show ? '' : 'none';
        el.setAttribute('aria-hidden', show ? 'false' : 'true');
      }

      // Optional: update aria-current on non-splide thumbs
      function setActiveThumb(mediaId) {
        nonSplideNodes.forEach((el) => el.setAttribute('aria-current', 'false'));
        const active = nonSplideNodes.find((el) => String(el.dataset.mediaId) === String(mediaId));
        if (active) active.setAttribute('aria-current', 'true');
      }

      // Click on non-splide thumb/grid item -> just update aria-current (Splide itself is separate)
      // nonSplideNodes.forEach((el) => {
      //   el.addEventListener('click', () => setActiveThumb(el.dataset.mediaId));
      // });
      nonSplideNodes.forEach((thumb) => {
  thumb.addEventListener('click', () => {
    const mediaId = String(thumb.dataset.mediaId);

    // update aria UI
    setActiveThumb(mediaId);

    // find corresponding splide
    splideEls.forEach((splideEl) => {
      const splide = getSplideInstance(splideEl);
      const map = mediaIndexMap.get(splideEl);
      if (!splide || !map) return;

      const index = map[mediaId];
      if (typeof index === 'number') {
        splide.go(index);   // THIS IS THE ACTUAL MAIN IMAGE CHANGE
      }
    });
  });
});


      function filterGalleryByVariant(variant) {
        const selectedOptions = Array.isArray(variant?.options) ? variant.options.map(normLower) : [];
        if (!selectedOptions.length) {
          // show all non-splide nodes
          nonSplideNodes.forEach((el) => setVisibilityNonSplide(el, true));
          // restore all splides
          splideEls.forEach((el) => rebuildSplide(el, null));
          return;
        }

        // Build allowed media IDs by matching ALT tag to ANY selected option value
        const allowedIds = new Set();
        mediaTagById.forEach((tag, mediaId) => {
          if (selectedOptions.includes(normLower(tag))) allowedIds.add(String(mediaId));
        });

        // Filter non-splide nodes (safe)
        let firstVisibleId = null;
        let visibleCount = 0;

        nonSplideNodes.forEach((el) => {
          const mediaId = String(el.dataset.mediaId || '');
          const tag = mediaTagById.get(mediaId);
          const matches = tag ? selectedOptions.includes(normLower(tag)) : false;

          setVisibilityNonSplide(el, matches);

          if (matches) {
            visibleCount++;
            if (!firstVisibleId) firstVisibleId = mediaId;
          }
        });

        // If nothing matched -> fallback show all
        if (visibleCount === 0) {
          nonSplideNodes.forEach((el) => setVisibilityNonSplide(el, true));
          splideEls.forEach((el) => rebuildSplide(el, null));
          return;
        }

        // ✅ Splide-safe: rebuild slide lists instead of display:none
        splideEls.forEach((el) => rebuildSplide(el, allowedIds));

        if (firstVisibleId) setActiveThumb(firstVisibleId);
        // ---- ADD THIS BLOCK HERE for image changing issue on product page ----
if (variant && variant.featured_media) {
  const mediaId = String(variant.featured_media.id);

  splideEls.forEach((splideEl) => {
    const splide = getSplideInstance(splideEl);
    const map = mediaIndexMap.get(splideEl);
    if (!splide || !map) return;

    const index = map[mediaId];
    if (typeof index === 'number') {
      splide.go(index);
    }
  });
}
// ---- END ----
      }

      // Listen to your variant change event, but only react if variant belongs to this productData
      document.addEventListener('ats:variant:change', (ev) => {
        const v = ev.detail;
        if (!v || !productData?.variants?.length) return;

        const belongsHere = productData.variants.some((x) => String(x.id) === String(v.id));
        if (!belongsHere) return;

        filterGalleryByVariant(v);
      });
    }

    /* =========================================================
       Qty stepper + sync to hidden input in form
    ========================================================= */
    const qtyWrap = root.querySelector('[data-ats-qty]');
    const qtyInput = qtyWrap?.querySelector("input[name='quantity']");
    const qtyHidden = root.querySelector('input[data-qty-hidden]');
    function syncQ() {
      if (qtyHidden && qtyInput) qtyHidden.value = qtyInput.value || '1';
    }
    if (qtyWrap && qtyInput) {
      const min = Number(qtyWrap.dataset.min || 1);
      const max = Number(qtyWrap.dataset.max || 0);
      const step = Number(qtyWrap.dataset.step || 1);
      const clamp = (n) => Math.max(min, max > 0 ? Math.min(n, max) : n);
      qtyWrap.querySelector('[data-qty-dec]')?.addEventListener('click', () => {
        qtyInput.value = clamp(parseInt(qtyInput.value || min, 10) - step);
        syncQ();
      });
      qtyWrap.querySelector('[data-qty-inc]')?.addEventListener('click', () => {
        qtyInput.value = clamp(parseInt(qtyInput.value || min, 10) + step);
        syncQ();
      });
      ['input', 'change'].forEach((ev) => qtyInput.addEventListener(ev, syncQ));
      syncQ();
    }

    /* =========================================================
       Copy link buttons
    ========================================================= */
    root.querySelectorAll('[data-copy]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(btn.dataset.copy);
          const old = btn.innerHTML;
          btn.innerHTML = 'Copied!';
          setTimeout(() => {
            btn.innerHTML = old;
          }, 1200);
        } catch (e) {}
      });
    });

    /* =========================================================
       Variant UI: options -> find variant -> set hidden id
    ========================================================= */
    const ui = root.querySelector('[data-ats-variant-ui]');
    const formVariantInput = root.querySelector('input[data-variant-input]');

    // ---- Sync UI with real Shopify variant input ----
if (formVariantInput && productData) {
  let lastId = formVariantInput.value;

  const syncFromInput = () => {
    const id = formVariantInput.value;
    if (!id || id === lastId) return;

    lastId = id;

    const variant = productData.variants.find(v => String(v.id) === String(id));
    if (!variant) return;

    // update UI highlight
    updateUISelected(variant.options || []);
    updateLabels(variant.options || []);
  };

  // observe programmatic changes (Shopify changes value without event)
  const observer = new MutationObserver(syncFromInput);
  observer.observe(formVariantInput, { attributes: true, attributeFilter: ['value'] });

  // also listen to manual changes
  formVariantInput.addEventListener('change', syncFromInput);
}


    const normOpt = (s) =>
      String(s || '')
        .replace(/\u00A0/g, ' ')
        .trim();
  


    function readGroupValue(g) {
      const on = g.querySelector(`${CLICK_SELECTOR}.is-selected`);
      if (on) return on.dataset.value;
      const sel = g.querySelector('select.ATS-var__select');
      if (sel) return sel.value;
      const first = g.querySelector(CLICK_SELECTOR);
      return first ? first.dataset.value : null;
    }

    function getSelectedOptions() {
      const arr = [];
      ui?.querySelectorAll('[data-option-index]').forEach((g) => {
        const idx = parseInt(g.getAttribute('data-option-index'), 10);
        arr[idx] = readGroupValue(g);
      });
      return arr;
    }

    function findVariantByOptions(selected) {
      if (!productData || !productData.variants) return null;
      return productData.variants.find((v) =>
        (v.options || []).map(normOpt).every((opt, i) => opt === normOpt(selected[i])),
      );
    }

    function updateLabels(sel) {
      sel.forEach((val, i) => {
        const el = root.querySelector(`.pdp-selected[data-label-for="${i}"]`);
        if (el && val) el.textContent = val;
      });
    }

    function updateUISelected(sel) {
      ui?.querySelectorAll('[data-option-index]').forEach((g) => {
        const idx = parseInt(g.getAttribute('data-option-index'), 10);
        const want = normOpt(sel[idx]);
        g.querySelectorAll(CLICK_SELECTOR).forEach((btn) => {
          btn.classList.toggle('is-selected', normOpt(btn.dataset.value) === want);
        });
        const selEl = g.querySelector('select.ATS-var__select');
        if (selEl && typeof sel[idx] === 'string') selEl.value = sel[idx];
      });
    }

    function updateATCState(variant) {
      const form = root.querySelector('product-form form');
      const atcBtn = form?.querySelector('button[data-atc]');
      const dynPayWrap = form?.querySelector('.shopify-payment-button');
      if (!atcBtn) return;

      if (!atcBtn.dataset.label) {
        atcBtn.dataset.label = atcBtn.textContent.trim() || 'Add to cart';
      }

      const qty = typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : null;
      const canBackorder = variant.inventory_policy === 'continue';
      const isSellable = !!variant.available && (qty === null || qty > 0 || canBackorder);

      if (isSellable) {
        atcBtn.disabled = false;
        atcBtn.removeAttribute('aria-disabled');
        atcBtn.classList.remove('is-sold-out');
        atcBtn.textContent = atcBtn.dataset.label;
        dynPayWrap?.classList.remove('tw-hidden');
      } else {
        atcBtn.disabled = true;
        atcBtn.setAttribute('aria-disabled', 'true');
        atcBtn.classList.add('is-sold-out');
        atcBtn.textContent = 'Sold out';
        dynPayWrap?.classList.add('tw-hidden');
      }
    }

    let currentVariant = null;
    function setCurrentVariant(variant) {
      if (!variant) return;
      currentVariant = variant;
      if (formVariantInput) formVariantInput.value = variant.id;
      updateLabels(variant.options || []);
      updateUISelected(variant.options || []);
      updateATCState(variant);
      document.dispatchEvent(new CustomEvent('ats:variant:change', { detail: variant }));
    }

    if (ui && formVariantInput && productData) {
      ui.addEventListener('click', (e) => {
        const btn = e.target.closest(CLICK_SELECTOR);
      
   

        if (!btn) return;
        const g = btn.closest('[data-option-index]');
        const idx = parseInt(g.getAttribute('data-option-index'), 10);
        const sel = getSelectedOptions();
        sel[idx] = btn.dataset.value;
        const v = findVariantByOptions(sel);
        if (v) setCurrentVariant(v);
      });

      ui.addEventListener('change', (e) => {
        const selEl = e.target.closest('select.ATS-var__select');
        if (!selEl) return;
        const g = selEl.closest('[data-option-index]');
        const idx = parseInt(g.getAttribute('data-option-index'), 10);
        const sel = getSelectedOptions();
        sel[idx] = selEl.value;
        const v = findVariantByOptions(sel);
        if (v) setCurrentVariant(v);
      });

      const byId = (id) => productData.variants.find((v) => String(v.id) === String(id));
      setCurrentVariant(
        byId(formVariantInput.value) || productData.variants.find((v) => v.available) || productData.variants[0],
      );
    }

    /* =========================================================
       Make desktop 'Qty + Add to cart' row
    ========================================================= */
    const form = root.querySelector('product-form form');
    const atc = form?.querySelector('button[data-atc]');
    const qty = root.querySelector('[data-ats-qty]');
    if (form && atc && qty) {
      const row = document.createElement('div');
      row.className = 'ATS-atcRow tw-gap-3';
      atc.parentNode.insertBefore(row, atc);
      row.appendChild(qty);
      row.appendChild(atc);
    }
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', initAll);
})();

/* ==== ATS PDP — throttle /cart/add.js ==== */
(() => {
  let t = 0,
    W = 1000,
    F = fetch;
  fetch = (...a) => {
    const u = a[0];
    if (typeof u === 'string' && u.includes('/cart/add.js')) {
      const n = Date.now();
      if (n - t < W) return new Response('{}', { status: 204 });
      t = n;
    }
    return F(...a);
  };
})();

//  code start for progress bar of the splide

(function () {
  function safeParse(str) {
    try {
      return JSON.parse(str);
    } catch (e) {
      return {};
    }
  }

  function start() {
    var el = document.querySelector('.ATS-splide.splide');
    if (!el) return;

    var bar = el.querySelector('.my-carousel-progress-bar');
    if (!bar) return;

    var opts = safeParse(el.getAttribute('data-ats-splide') || '{}');

    // ✅ force-hide via JS too (in case)
    opts.arrows = false;
    opts.pagination = false;

    var splide = new Splide(el, opts);

    function update(indexMaybe) {
      var end = splide.Components.Controller.getEnd();
      var total = end + 1;
      var idx = typeof indexMaybe === 'number' ? indexMaybe : splide.index;
      var rate = total <= 1 ? 1 : Math.min((idx + 1) / total, 1);
      bar.style.width = rate * 100 + '%';
    }

    splide.on('mounted', function () {
      update(splide.index);
    });
    splide.on('move', function (newIndex) {
      update(newIndex);
    });
    splide.on('moved', function (newIndex) {
      update(newIndex);
    });
    splide.on('dragged', function () {
      update(splide.index);
    });

    splide.mount();
    update(splide.index);
  }

  function wait() {
    if (window.Splide) return start();
    setTimeout(wait, 100);
  }
  wait();
})();

//  code end for progress bar of the splide

